import { useState } from 'react'

import { meetingApi } from '../api'

const useDeleteMeeting = () => {
  const [isDeleting, setIsDeleting] = useState(false)

  const deleteMeeting = async (meetingId: string) => {
    setIsDeleting(true)

    try {
      await meetingApi.deleteMeeting(meetingId)
    } catch (error) {
      console.error('Failed to delete meeting', error)
    } finally {
      setIsDeleting(false)
    }
  }

  return { isDeleting, deleteMeeting }
}

export default useDeleteMeeting
